"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.regexp.split");








































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      droplist: [], imageSrcList: [], searchData: { sn: '', currentVersion: '', targetVersion: '', status: '', createStart: '', createEnd: '', reportTime: [], type: '1', // 当前页码
        page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, // 表格列
      tableColumns: [{ prop: 'sn', label: '设备序列号', isShow: true }, { prop: 'currentVersion', label: '当前版本', isShow: true }, { prop: 'targetVersion', label: '目标版本', isShow: true }, { prop: 'status', label: '状态', formatter: _formatter.upgradeStatusFormatter, isShow: true }, { prop: 'createTime', label: '上报时间', formatter: _formatter.dateFormatter, isShow: true }] };}, mounted: function mounted() {var self = this;self.init();}, methods: { init: function init() {var self = this;var params = Object.assign({}, self.searchData);delete params['reportTime'];self.getData('/api/faOtaVersionLog', params, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, checkPermission: _user.checkPermission, resetFun: function resetFun() {// 重置
      this.searchData.sn = '';this.searchData.currentVersion = '';this.searchData.targetVersion = '';this.searchData.status = '';this.searchData.reportTime = [];this.searchData.createStart = '';this.searchData.createEnd = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      if (this.searchData.reportTime.length > 1) {this.searchData.createStart = this.searchData.reportTime[0];this.searchData.createEnd = this.searchData.reportTime[1];}this.searchData.page = 1;if (this.searchData.createStart && this.searchData.createStart.split(' ').length < 2) {this.searchData.createStart += ' 00:00:00';}if (this.searchData.createEnd) {var endTime = this.searchData.createEnd;if (endTime.split(' ').length < 2) {endTime = endTime + ' 23:59:59';this.searchData.createEnd = endTime;}}this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();} } };exports.default = _default;